"use client";

import { useEffect, useRef, useState } from "react";

// Sizes the iframe to the height the animation reports via postMessage
// ({ type: "dash0-animation-height", height }), so one embed works at every width.
export default function AnimationFrame({
  src,
  title,
  initialHeight,
}: {
  src: string;
  title: string;
  initialHeight: number;
}) {
  const ref = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(initialHeight);
  const requestHeight = () =>
    ref.current?.contentWindow?.postMessage({ type: "dash0-animation-height-request" }, window.location.origin);

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.source !== ref.current?.contentWindow || e.origin !== window.location.origin) return;
      if (e.data?.type === "dash0-animation-height" && typeof e.data.height === "number" && e.data.height > 0) {
        setHeight(Math.ceil(e.data.height));
      }
    };
    window.addEventListener("message", onMessage);
    // The iframe may have loaded and posted its height before hydration, so ask again.
    requestHeight();
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <iframe
      ref={ref}
      src={src}
      title={title}
      onLoad={requestHeight}
      className="block w-full border-0 bg-transparent"
      style={{ height, overflow: "hidden" }}
    />
  );
}
